
import { useTranslation } from "react-i18next";
import { COMMISSION_POLICY } from "utils/constants/Constants";
import { Table } from "@sentara-health/optimahealth_web";

export default function CommissionPolicyTable1() {
  const { t } = useTranslation();
  const header = [
    { text: t("commissionPolicy.billedContracts") },
    { text: t("commissionPolicy.newSale") },
    { text: t("commissionPolicy.renewal") },
  ]

  const getComissionPolicyData = () => {
    let singleRowData = []
    let tableRowData = []

    singleRowData.push({ text: COMMISSION_POLICY.ENTROLLED1 })
    singleRowData.push({ text: COMMISSION_POLICY.NEWSALES1 })
    singleRowData.push({ text: COMMISSION_POLICY.RENEWAL1 })
    tableRowData.push(singleRowData)

    singleRowData = []
    singleRowData.push({ text: COMMISSION_POLICY.ENTROLLED2 })
    singleRowData.push({ text: COMMISSION_POLICY.NEWSALES2 })
    singleRowData.push({ text: COMMISSION_POLICY.RENEWAL2 })
    tableRowData.push(singleRowData)

    singleRowData = []
    singleRowData.push({ text: COMMISSION_POLICY.ENTROLLED3 })
    singleRowData.push({ text: COMMISSION_POLICY.NEWSALES3 })
    singleRowData.push({ text: COMMISSION_POLICY.RENEWAL3 })
    tableRowData.push(singleRowData)

    singleRowData = []
    singleRowData.push({ text: COMMISSION_POLICY.ENTROLLED4 })
    singleRowData.push({ text: COMMISSION_POLICY.NEWSALES4 })
    singleRowData.push({ text: COMMISSION_POLICY.RENEWAL4 })
    tableRowData.push(singleRowData)

    return tableRowData
  }

  return (
    <div className="row justify-content-center">
      <div className="col-lg-10 col-md-9 col-sm-12 col-12">
        <div className="text-center mb-3 mt-2">
          <strong> {t("commissionPolicy.tableHeader1")}</strong>
          <strong className="redhat_bolditalic">{t("commissionPolicy.commissionScheduleEdge")}</strong>
          <strong> {t("commissionPolicy.tableHeader1.1")}</strong>
        </div>
        <Table
          data-testid="tblSmallGroupAndMidMarket"
          header={header}
          rows={getComissionPolicyData()} />
      </div>
    </div>
  );
}
